import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── OpsIQ ───────────────────────────────────────────────────────────────────
// Persona: Head of RevOps
// Data sources: See constants/modules.js

const KPIs = [
  { label: "CRM Data Quality", value: "87%", delta: "+5pts QoQ", color: "#059669" },
  { label: "Stage Compliance", value: "94%", delta: "Process adherence", color: "#059669" },
  { label: "Tool Adoption", value: "78%", delta: "Active users", color: "#d97706" },
  { label: "Missing Close Dates", value: "14%", delta: "Open opps", color: "#e11d48" },
  { label: "Stale Deals (30d+)", value: "22", delta: "No activity", color: "#e11d48" },
  { label: "Activity Logging", value: "91%", delta: "Calls + emails", color: "#059669" }
];
const CHART_DATA = [
  {
    "field": "Close Date",
    "score": 86
  },
  {
    "field": "Deal Value",
    "score": 92
  },
  {
    "field": "Stage",
    "score": 97
  },
  {
    "field": "Next Steps",
    "score": 71
  },
  {
    "field": "Contact Role",
    "score": 64
  },
  {
    "field": "Competitor",
    "score": 58
  }
];

export default function OpsIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>CRM Data Quality by Field (%)</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="field" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          
          <Bar dataKey="score" fill="#0891b2" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Contact role and competitor fields are severely under-populated — this is directly impairing win/loss analysis accuracy.</p>
        </div>
      </div>
    </div>
  );
}
